import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './AsStandInLabel.module.scss';

interface AsStandInLabelProps {
  marginLeft?: number | string;
  marginRight?: number | string;
  isInput?: boolean;
  actionButton?: boolean;
  height?: number | string;
}

const AsStandInLabel: React.FC<AsStandInLabelProps> = ({ height = 'auto', marginLeft = 0, marginRight = 0, isInput = false, actionButton, ...props }) => {
  const { t } = useTranslation();

  return (
    <span
      className={`${styles.AsStandInLabel} ${actionButton ? styles.ActionButton : ''}`}
      style={{ marginLeft, marginRight, height, fontSize: isInput ? '15px' : 'unset' }}
      {...props}
    >
      {t('asStandin')}
    </span>
  );
};

export default AsStandInLabel;
